// extracted by mini-css-extract-plugin
export var caption = "styles-module--caption--VFvHj";
export var card = "styles-module--card--QFB2i";
export var clubLogo = "styles-module--clubLogo--Z8pfB";
export var profileCard = "styles-module--profileCard--RtcsN";
export var section = "styles-module--section--jjm4Z";
export var sectionColumns = "styles-module--sectionColumns--sF+Tc";
export var sectionHead = "styles-module--sectionHead--6VeVf";